import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=98392fa6&scoped=true&"
import script from "./selected.vue?vue&type=script&lang=ts&"
export * from "./selected.vue?vue&type=script&lang=ts&"
import style0 from "./selected.vue?vue&type=style&index=0&id=98392fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98392fa6",
  null
  
)

export default component.exports